// Image sources
export const SOURCE_WEBCAM = "SOURCE_WEBCAM";
export const SOURCE_FILE = "SOURCE_FILE";

// Image IDs
export const AFTER_IMAGE = "AFTER_IMAGE";
export const BEFORE_IMAGE = "BEFORE_IMAGE";

// action types
export const SET_SCREEN = "SET_SCREEN";
export const SET_IMAGE = "SET_IMAGE";
export const COMPLETE_STEP = "COMPLETE_STEP";
export const GO_TO_STEP = "GO_TO_STEP"
export const SET_IMAGE_SOURCE = "SET_IMAGE_SOURCE";
export const SET_COMPARE_TYPE = "SET_COMPARE_TYPE";
export const SET_SCREENSHOT_FORMAT = "SET_SCREENSHOT_FORMAT";
export const SET_PREFERRED_RES = "SET_PREFERRED_RES";
export const SET_ENABLE_BEFORE_OVERLAY = "SET_ENABLE_BEFORE_OVERLAY";

// compare types
export const COMPARE_AUTOMATIC = "COMPARE_AUTOMATIC";
export const COMPARE_SIDE_BY_SIDE = "COMPARE_SIDE_BY_SIDE";
export const COMPARE_SLIDER_RIGHT_LEFT = "COMPARE_SLIDER_RIGHT_LEFT";
export const COMPARE_CROSSFADE = "COMPARE_CROSSFADE";

//screens
export const SCREEN_MENU = "SCREEN_MENU";
export const SCREEN_STEPS = "SCREEN_STEPS";
export const SCREEN_SETTINGS = "SCREEN_SETTINGS";
export const SCREEN_HOW_IT_WORKS = "SCREEN_HOW_IT_WORKS";
export const SCREEN_PRIVACY = "SCREEN_PRIVACY";

//steps
export const STEP_BEFORE_PHOTO = "Before photo";
export const STEP_BETWEEN_PHOTOS = "Do your thing";
export const STEP_AFTER_PHOTO = "After photo";
export const STEP_COMPARE = "Compare photos";
